module.exports = __webpack_public_path__ + "img/logo-dark.734dd3de.png";